import React, { useState } from 'react'
import CampaignBuildAnimation from './CampaignBuildAnimation'
import { StyledLinkedinFlowReady } from './NewOnboarding.styles'

const LinkedinFlowReady = ({
    templateSteps = [],
    templateMessages = [],
    options = [],
    onSelectOption,
}) => {
    const [built, setBuilt] = useState(false)

    return (
        <StyledLinkedinFlowReady>
            <div className='diagram-holder'>
                <CampaignBuildAnimation
                    steps={templateSteps}
                    messages={templateMessages}
                    speed={0.5}
                    ending='stay'
                    successText='Your LinkedIn flow is ready to launch.'
                    style={{ width: '100%', height: 'clamp(240px, 40vh, 400px)' }}
                    onComplete={() => setBuilt(true)}
                />
            </div>

            {built && (
                <>
                    <span className='text'>Your LinkedIn outreach sequence is ready.</span>
                    <span className='text'>
                        I've created the first version based on your offer, target market and positioning.
                    </span>

                    {options?.length > 0 && (
                        <div className='btn-holder'>
                            {options.map(opt => (
                                <button
                                    key={opt.id}
                                    type='button'
                                    onClick={() => onSelectOption?.(opt)}
                                >
                                    {opt?.label}
                                </button>
                            ))}
                        </div>
                    )}
                </>
            )}
        </StyledLinkedinFlowReady>
    )
}

export default LinkedinFlowReady
